module.exports = __webpack_public_path__ + "img/周明婷实验师.dcb2b714.png";